import {
  ArrowForwardRounded,
  EmailOutlined,
  HourglassEmptyRounded,
  TaskAltRounded
} from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  Grid,
  Typography,
  alpha
} from '@mui/material';
import { Link as RRLink } from 'react-router-dom';
import Dashboard from '../../assets/Dashboard.png';
import GradientText from '../../components/GradientText';
import HeaderText from '../../components/HeaderText';
import { BACKSPACE_SERVICES } from '../../constants/backspaceServices';
import { BACKSPACE_TEAM_MEMBER } from '../../constants/backspaceTeamMember';

export default function Home() {
  return (
    <Box sx={{ mt: 3, mb: 10 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            mx: { xs: 'auto', md: 0 },
            mt: { xs: 8, sm: 12 },
            width: { xs: '100%', md: '50%' },
            maxWidth: { xs: '400px', md: '600px' }
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 'bold',
              textAlign: { xs: 'center', md: 'start' },
              fontSize: { xs: 40, sm: 48, md: 76 },
              lineHeight: '100%'
            }}
          >
            <GradientText>Move faster</GradientText> with Backspace digital
            tools
          </Typography>
          <Typography
            fontSize={16}
            sx={{
              mt: 2,
              mb: 4,
              textAlign: { xs: 'center', md: 'start' },
              color: 'text.secondary'
            }}
          >
            The Engineering and Construction System Department, also known as{' '}
            <Box
              component="span"
              sx={{
                letterSpacing: -1,
                fontFamily: 'Comfortaa',
                fontWeight: 700
              }}
            >
              backspace
            </Box>
            , was set up to make the engineering work go into digital format and
            make itself to be central of truth of all information. We hope
            everyone will work with smiles and happiness
          </Typography>
          <Box sx={{ mb: 3 }}>
            <Button
              variant="outlined"
              color="inherit"
              size="large"
              onClick={() => {
                window.location.href =
                  'mailto:tulanunj@scg.com,chawakot@scg.com,chayapbo@scg.com';
              }}
              startIcon={<EmailOutlined />}
              fullWidth
              sx={(theme) => ({
                borderColor: alpha(theme.palette.text.primary, 0.25)
              })}
            >
              Request Demo
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            width: '50%',
            display: { xs: 'none', md: 'block' },
            mt: 12
          }}
        >
          <img style={{ width: '100%' }} src={Dashboard} alt="dashboard" />
        </Box>
      </Box>
      <Divider sx={{ mt: 2, mb: 6 }} />
      <HeaderText>
        OUR <GradientText>SERVICES</GradientText>
      </HeaderText>
      <Grid container spacing={{ xs: 2 }}>
        {BACKSPACE_SERVICES.map(({ id, shortName, features, to }) => {
          return (
            <Grid item xs={12} sm={12} md={6} key={id}>
              <Card
                sx={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '16px',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <CardContent sx={{ px: 3, py: 1.5 }}>
                  <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
                    <Typography
                      component="span"
                      sx={{
                        fontSize: { xs: '1.6rem', sm: '1.9rem' },
                        letterSpacing: { xs: -1.5, sm: -2 },
                        fontFamily: 'Comfortaa',
                        fontWeight: 700
                      }}
                    >
                      space
                    </Typography>
                    <Typography
                      component="span"
                      sx={(theme) => ({
                        ml: 0.75,
                        px: 0.75,
                        py: 0.25,
                        background: theme.palette.gradient.main,
                        color: 'background.paper',
                        borderRadius: '8px',
                        fontFamily: 'Comfortaa',
                        fontWeight: 700
                      })}
                    >
                      {shortName}
                    </Typography>
                    <Box sx={{ flex: 1 }} />
                    {features.every((feature) => !feature.release) && (
                      <Chip
                        label="Coming soon..."
                        variant="outlined"
                        size="small"
                      />
                    )}
                  </Box>
                  {features.map(({ id, name, release }) => {
                    return (
                      <Box sx={{ display: 'flex', mb: 1 }} key={id}>
                        {release ? (
                          <TaskAltRounded color="success" sx={{ mr: 1 }} />
                        ) : (
                          <HourglassEmptyRounded
                            color="disabled"
                            sx={{ mr: 1 }}
                          />
                        )}
                        <Typography
                          color={release ? 'text.primary' : 'text.disabled'}
                        >
                          {name}
                        </Typography>
                      </Box>
                    );
                  })}
                </CardContent>
                <Box sx={{ flex: 1 }} />
                {false && (
                  <CardActions disableSpacing>
                    <Button
                      sx={(theme) => ({
                        ml: 'auto',
                        textTransform: 'none',
                        bgcolor: alpha(theme.palette.primary.main, 0.05)
                      })}
                      component={RRLink}
                      to={to}
                      endIcon={<ArrowForwardRounded />}
                    >
                      See details
                    </Button>
                  </CardActions>
                )}
              </Card>
            </Grid>
          );
        })}
      </Grid>
      <Divider sx={{ mt: 4, mb: 6 }} />
      <HeaderText>
        MEET THE <GradientText>BACKSPACE</GradientText> TEAM
      </HeaderText>
      <Grid container spacing={{ xs: 2 }}>
        {BACKSPACE_TEAM_MEMBER.map(
          (
            { firstName, lastName, position, email, responsibility, src },
            index
          ) => {
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}
                >
                  <Box
                    sx={(theme) => ({
                      display: 'flex',
                      justifyContent: 'center',
                      backgroundColor:
                        theme.palette.mode === 'light' ? '#dddddd' : '#555555'
                    })}
                  >
                    <img
                      src={src}
                      alt={`${firstName} ${lastName}`}
                      style={{ height: 200 }}
                    />
                  </Box>
                  <CardContent sx={{ pb: 0 }}>
                    <Typography
                      variant="h5"
                      noWrap
                      gutterBottom
                      sx={{
                        mx: 0.5,
                        mb: 0
                      }}
                    >
                      {`${firstName} ${lastName}`}
                    </Typography>
                    <Chip variant="outlined" size="small" label={position} />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                      sx={{ mx: 0.5, mt: 1 }}
                    >
                      {responsibility}
                    </Typography>
                  </CardContent>
                  <Box sx={{ flex: 1 }} />
                  <CardActions disableSpacing>
                    <Button
                      sx={(theme) => ({
                        textTransform: 'none',
                        bgcolor: alpha(theme.palette.primary.main, 0.05)
                      })}
                      size="small"
                      fullWidth
                      onClick={() => {
                        window.open(`mailto:${email}`, '_blank');
                      }}
                      startIcon={<EmailOutlined />}
                    >
                      {email}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          }
        )}
      </Grid>
    </Box>
  );
}
